import { Component, OnInit } from "@angular/core";
import { AuthDataStorageService } from "../../auth/services/auth-data-storage.service";
import { NavigationService } from "../services/navigation.service";

@Component({
  selector: "ch-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  public showSidebar: boolean;
  public routes: Array<{
    route?: string;
    label: string;
    badge?: number;
    hide?: boolean;
    subRoutes?: Array<{ route: string; label: string }>;
  }>;

  constructor(
    private authDataStorageService: AuthDataStorageService,
    private navigationService: NavigationService,
  ) {
    this.routes = [
      {
        route: "dashboard",
        label: "Dashboard",
      },
      {
        route: "members",
        label: "Members",
      },
      {
        route: "members-for-verification",
        label: "Pending Verification",
      },
      {
        route: "verification-codes",
        label: "Verification Codes",
      },
      {
        route: "offers",
        label: "Offers",
      },
      {
        route: "offer-redemptions",
        label: "Offer Redemptions",
      },
      {
        route: "membership-codes",
        label: "Promo Codes",
        hide: this.isRestrictedUser,
      },
      {
        route: "referral-programs",
        label: "Referral Programs",
        hide: this.isRestrictedUser,
      },
      {
        route: "admin-users",
        label: "Admin Users",
        hide: this.isRestrictedUser,
      },
      {
        route: "notifications",
        label: "Notifications",
        hide: this.isRestrictedUser,
      },
      {
        route: "subscription-plans",
        label: "Subscription Plans",
        hide: this.isRestrictedUser,
      },
      {
        route: "exit-survey",
        label: "Exit Survey",
        hide: this.isRestrictedUser,
      },
      {
        label: "Reference data",
        hide: this.isRestrictedUser,
        subRoutes: [
          {
            route: "locations",
            label: "Locations",
          },
          {
            route: "offer-types",
            label: "Offer Types",
          },
          {
            route: "offer-tags",
            label: "Offer Tags",
          },
          {
            route: "job-categories",
            label: "Job Categories",
          },
          {
            route: "pages",
            label: "Pages",
          },
          {
            route: "sponsors",
            label: "Sponsors",
          },
          {
            route: "whitelisted-domains",
            label: "Whitelisted Domains",
          },
          {
            route: "app-versions",
            label: "App Versions",
          },
          {
            route: "coupons",
            label: "Coupons",
          },
          {
            route: "cancel-subscription",
            label: "Cancel subscription",
          },
          {
            route: "emails",
            label: "Emails",
          },
          {
            route: "ab-tests",
            label: "AB Tests",
          },
        ],
      },
    ];

    navigationService.showSidebar.subscribe((show: boolean) => {
      this.showSidebar = show;
    });
  }

  ngOnInit() {}

  get isRestrictedUser() {
    return this.authDataStorageService.isUserRestricted();
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/sidebar/sidebar.component.ts